import gql from "graphql-tag";

export const SetUserPasswordMutation = gql`
  mutation setUserPassword($token: String!, $password: String!) {
    setUserPassword(token: $token, password: $password) {
      emailAddress
    }
  }
`;
